import HeaderMyOrder from './header-my-order.jpg';
import BannerMinhaConta from './image-banner-minha-conta.jpg';
import BannerMinhasViagens from './image-banner-minhas-viagens.jpg';

export const ALL_MY_ACCOUNT = {
  HeaderMyOrder,
  BannerMinhaConta,
  BannerMinhasViagens,
};
